import gql from 'graphql-tag'

export const GET_USER_DOCS = gql`
query UserDocs($filter: GetUserDocInputType!) {
  userDocs(filter: $filter) {
    isSuccessful
    message
    userDoc {
      fullname
      userId
      docType
      docNumber
      validUntil
      status
    }
  }
}`

export const UPDATE_USER_DOCS = gql`
mutation UpdateUserDoc($input: CreateUserDocInput!) {
  updateUserDoc(input: $input) {
    isSuccessful
    message
    updateUserDoc {
      fullname
      userId
      docType
      docNumber
      validUntil
      status
    }
  }
}`

export const IMPORT_USER_DOCS = gql`
mutation ImportUserDoc($input: ImportUserDocInput!) {
  importUserDoc(input: $input) {
    importUserDoc {
      errorFile
      totalData
      totalFailed
      totalSuccess
    }
    isSuccessful
    message
  }
}`


export const DOWNLOAD_EXCEL_USERDOCS = gql`
query DownloadUserDoc($filter: GetUserDocInputType!) {
  downloadUserDocs(filter: $filter) {
    downloadUserDoc {
      base64
    }
    isSuccessful
    message
  }
}`
